<template>
	<div v-if="data" class="sub-values inline">
		<div class="sub-value">
			<div class="label clickable" @click="$emit('click')">
				<template v-if="type === 'immediately'">Ab sofort</template>
				<template v-else-if="date">Ab {{ data.date | dateByObject }}</template>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			required: false
		}
	},

	computed: {
		type ()
		{
			return this.data?.type;
		},
		date ()
		{
			return this.data?.date;
		},
	}
}
</script>
